module.exports = __webpack_public_path__ + "img/medication.a552685b.svg";